import { Box, Heading, Text } from '@chakra-ui/react'
import { FC, useMemo } from 'react'
import Chart from 'react-apexcharts'

import { parseCurrency } from '@helper/parseCurrency'

import { IGraphActualSales } from '@base/@types/providers/HomeProvider'

import ChartsLoading from '../Loading'

interface IActualSaleVersusBudgetedSalesChartsProps {
  dataActualSales: IGraphActualSales
}

const ActualSaleVersusBudgetedSalesChartsExport: FC<IActualSaleVersusBudgetedSalesChartsProps> =
  ({ dataActualSales }) => {
    const chart = useMemo(() => {
      const hasData =
        dataActualSales.vendaOrcada === 0 && dataActualSales.vendaReal === 0

      return {
        options: {
          chart: {
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              dataLabels: {
                position: 'top'
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val: string) {
              return (
                'R$' +
                parseCurrency({
                  value: Number(val),
                  country: 'pt-br',
                  minFraction: 0,
                  maxFraction: 0
                })
              )
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#304758']
            }
          },
          noData: {
            text: 'Não há dados suficiente para completar o gráfico'
          },
          xaxis: {
            categories: ['Valores'],
            labels: {
              show: false
            }
          },
          animations: {
            enabled: false
          },
          grid: {
            show: !hasData
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          tooltip: {
            x: {
              show: false,
              formatter: undefined
            },
            y: {
              formatter: (val: any) =>
                'R$' +
                parseCurrency({
                  value: Number(val),
                  country: 'pt-br',
                  minFraction: 0,
                  maxFraction: 0
                }),

              title: {
                formatter: (x: any) => x
              }
            }
          }
        },
        series: hasData
          ? []
          : [
              {
                name: 'Orçado',
                data: [dataActualSales.vendaOrcada]
              },
              {
                name: 'Realizado',
                data: [dataActualSales.vendaReal]
              }
            ]
      }
    }, [dataActualSales.vendaOrcada, dataActualSales.vendaReal])

    // useEffect(() => {
    //   if (
    //     dataActualSales.vendaOrcada === null &&
    //     dataActualSales.vendaReal === null
    //   ) {
    //     getDataActualSales(empresas)
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [empresas])

    return (
      <Box p={6} bg="white" borderRadius="8px" boxShadow="sm">
        <Heading size="lg">Venda Real x Venda Orcada</Heading>
        <Text fontSize="md" color="gray.600" mb={6}>
          Venda acumulada do mes corrente
        </Text>
        <ChartsLoading isLoaded={true}>
          <Chart
            options={chart.options}
            series={chart.series}
            type="bar"
            width="100%"
            height="320px"
          />
        </ChartsLoading>
      </Box>
    )
  }

export default ActualSaleVersusBudgetedSalesChartsExport
